import React from 'react';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../../../constants/app';
import Button from '../../../../ui-core/Button/Button';

import './style.css';

export const PlanBegins = ({ onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(TEXT_CONSTANT.JOIN_NOW, 'isSignup', TEXT_CONSTANT.WHAT_YOU_GET);
    }
  };
  return (
    <div className="plan-begins">
      <div className="pb-head">
        <p>
          The Plan <span>Begins...</span>
        </p>
        <h3>
          Jan
          <img src={IMAGE_CONSTANT.planBeings} alt="jen" />
          <span>1</span>
        </h3>
      </div>
      <div className="d-flex justify-content-center align-items-center pb-offer">
        {/* <Offer coupon="MOBILITY" mode="dark" /> */}
        <Button
          onClick={handleClick}
          text={TEXT_CONSTANT.JOIN_NOW}
          class="sign-up-button-new text-uppercase mb-5 ms-4"
        />
      </div>
    </div>
  );
};

PlanBegins.propTypes = {
  onClick: PropTypes.func,
};
